import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const richHtmlBlock = {
  moveRichHtmlBlock: lazyModuleMethod(
    () => import('./moveRichHtmlBlock'),
    'default'
  ),
}
